const actionKeys = {
  loadSkill: 'loadSkill',
  addSkill: 'addSkill',
  removeSkill: 'removeSkill',
};

const loadSkills = (allSkills) => async (dispatch) => {
  dispatch({
    type: actionKeys.loadSkill,
    payload: {
      allSkills: allSkills,
    },
  });
};

const add = (skill) => async (dispatch) => {
  dispatch({
    type: actionKeys.addSkill,
    payload: {
      skill: skill,
    },
  });
};

const remove = (skillRn) => async (dispatch) => {
  dispatch({
    type: actionKeys.removeSkill,
    payload: {
      skillRn: skillRn,
    },
  });
};

const defaultState = {
  allSkills: [],
};

const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case actionKeys.loadSkill:
      return {
        allSkills: action.payload.allSkills,
        lastLoadTime: new Date().toISOString(),
      };
    case actionKeys.addSkill:
      return {
        ...state,
        allSkills: [...state.allSkills, action.payload.skill],
        lastLoadTime: new Date().toISOString(),
      };
    case actionKeys.removeSkill:
      return {
        ...state,
        allSkills: state.allSkills.filter((skill) => skill.skillRn !== action.payload.skillRn),
        lastLoadTime: new Date().toISOString(),
      };
    default:
      return state;
  }
};


export default {
  actions: {
    loadSkills,
    add,
    remove,
  },
  reducer: reducer,
  defaultState: defaultState,
};
